module.exports = __webpack_public_path__ + "img/DE00327.07abcf66.png";